import * as React from 'react';

export const VisuallyHidden = React.forwardRef<
  HTMLElement,
  React.PropsWithChildren<{ as?: any }>
>(({ children, as: Component = 'span', ...props }, ref) => {
  const style: React.CSSProperties = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px',
  };

  return (
    <Component ref={ref} style={style} {...props}>
      {children}
    </Component>
  );
});

VisuallyHidden.displayName = 'VisuallyHidden';

export default VisuallyHidden;
